import "lazysizes";
import Scrollbar from "smooth-scrollbar";
import BezierEasing from "bezier-easing";

// SCROLL
// -- Init
var scaleratio = $(window).outerHeight() / 1000;
var aniComplete = true;
if ($(".regular").hasClass("active")) {
  scrollbars["bxh1"] = Scrollbar.init($(".list-data-bxh")[0], {
    alwaysShowTracks: true,
  });
}
if ($(".top-ranking").hasClass("active")) {
  scrollbars["bxh1"] = Scrollbar.init($(".list-data-bxh")[1], {
    alwaysShowTracks: true,
  });
}

if ($(".scrollContent").length > 0) {
  let frameSwipe = {
    total: 5,
    frames: [
      ".section--1",
      ".section--2",
      ".section--3",
      ".section--4",
      ".section--5",
      ".section--6",
      ".section--7",
      ".section--footer",
    ],
    navigation: ".nav-top li",
    index: 0,
    isEndAnimate: true,
    animateDelay: 400,
    animateEndDelay: 400,
  };

  $(".scrollLink").on("click", function (e) {
    e.preventDefault();
    if (frameSwipe.isEndAnimate) {
      frameSwipe.isEndAnimate = false;

      $("html").animate(
        {
          scrollTop: $($(this).data("scroll-link")).offset().top,
        },
        600,
        function () {
          frameSwipe.isEndAnimate = true;
        }
      );
    }
  });
}

import Swiper from "Swiper";
import "swiper/css/swiper.min.css";

var charswiper = new Swiper(".char-swiper", {
  effect: "fade",
  // loop: true,
  slidesPerView: "auto",
  centeredSlides: true,
  preloadImages: false,
  // Enable lazy loading
  lazy: {
    loadPrevNext: true,
  },
  navigation: {
    nextEl: ".next-f5",
    prevEl: ".prev-f5",
  },
});
var charswiperbullet;
if (!viewportIsMobile($("body").outerWidth())) {
  charswiperbullet = new Swiper(".char-swiper-bullet", {
    preloadImages: false,
    // Enable lazy loading
    lazy: {
      loadPrevNext: true,
    },
    slidesPerView: 8,
    allowTouchMove: false,
  });
} else {
  charswiperbullet = new Swiper(".char-swiper-bullet", {
    preloadImages: false,

    // Enable lazy loading
    lazy: {
      loadPrevNext: true,
    },
    slidesPerView: 6,

    navigation: {
      nextEl: ".btn-next",
      prevEl: ".btn-back",
    },
  });
  charswiperbullet.on("slideChange", function () {
    $(".btn-bullet-char").removeClass("active");
    $(".btn-bullet-char").eq(charswiperbullet.realIndex).click();
  });
}

let targetf2;
$(".btn-bullet-char").click(function (e) {
  e.preventDefault();
  targetf2 = $(this).data("target");
  $(".btn-bullet-char").removeClass("active");
  $(this).addClass("active");
  charswiper.slideTo(targetf2, 300, false);
  charswiperbullet.slideTo(targetf2, 300, false);
});
charswiper.on("slideChange", function () {
  $(".btn-bullet-char").removeClass("active");
  $(".btn-bullet-char").eq(charswiper.realIndex).addClass("active");
  charswiperbullet.slideTo(charswiper.realIndex, 300, false);
});
function viewportIsMobile(width) {
  return width < 1025;
}
